const ReportAttrs = {
  WithoutCustomDateRange: 'withoutCustomDateRange'
};
export const ParamterNames = {
  Plant: 'Plant',
  SecurityContextId: 'SecurityContextId',
  AssetList: 'AssetList',
  Datapoint: 'DataPointList',
};

export const ConstantValues = {
  All: 'All'
};

export const reportHasAssetListParam = (params = []) => !!(params || []).find(p => p.name === ParamterNames.AssetList);
export const doNotSupportCustomRang = attrs => !!(attrs && attrs[ReportAttrs.WithoutCustomDateRange]);
export class Report {
  constructor(apiReportModel) {
    apiReportModel = apiReportModel || {};
    this.id = apiReportModel.id;
    this.name = apiReportModel.name;
    this.viewPath = apiReportModel.viewPath;
    this.parameters = apiReportModel.parameters;
    this.attrs = apiReportModel.attrs;
    this.exportOptions = apiReportModel.exportOptions;
    this.description = apiReportModel.description;
    this.type = apiReportModel.type;
    this.filters = apiReportModel.filters || [];
    this.requiredAssets = reportHasAssetListParam(this.parameters);
    this.doNotSupportCustomRang = doNotSupportCustomRang(this.attrs);
  }
}
